/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { useUnstyled as i, classNames as c, uDropDownsBase as d } from "@progress/kendo-react-common";
import * as l from "react";
const u = (e) => {
  const { group: s, groupMode: n, render: r } = e, t = i(), a = t && t.uDropDownsBase, o = /* @__PURE__ */ l.createElement("div", { className: c(d.groupStickyHeader({ c: a })) }, n === "classic" ? s : /* @__PURE__ */ l.createElement("div", { className: c(d.listHeaderText({ c: a })) }, s));
  return r !== void 0 ? r.call(void 0, o, e) : o;
};
export {
  u as default
};
